import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import './Waitlist.css';

const Waitlist = () => {
  const { user, logout, loading } = useAuth();

  if (loading) return <div>Loading...</div>;
  if (!user) return <Navigate to="/login" replace />;
  if (user.status === 'active') return <Navigate to="/" replace />;

  return (
    <div className="waitlist-page">
      <div className="waitlist-card">
        <h2 className="welcome-title">You're on the waitlist</h2>
        <p className="subtitle">Thanks for signing up, {user.email}.</p>

        {user.waitlistPosition != null && (
          <div className="waitlist-position">
            <span className="waitlist-position-label">Your position</span>
            <span className="waitlist-position-number">#{user.waitlistPosition}</span>
          </div>
        )}

        <p className="waitlist-body">
          Looway is currently rolling out to a limited group of users. We'll email
          you at <strong>{user.email}</strong> as soon as a spot opens up.
        </p>

        <button className="login-button" onClick={logout}>
          Sign out
        </button>
      </div>
    </div>
  );
};

export default Waitlist;
